import { render } from "./Home.vue?vue&type=template&id=6c941b8f&scoped=true"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=6c941b8f&scoped=true&lang=css"

import exportComponent from "/home/pdu/dbesslnc/v1/v1/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c941b8f"]])

export default __exports__